let previousHeight: number = 0;
const REMOVE_SCROLLBARS = 4;

function sendMessageToParent(message: unknown): void {
  window.parent.postMessage(message, "*");
}

function onResize(target: HTMLElement, embedID: string) {
  const height = target.offsetHeight + REMOVE_SCROLLBARS;

  if (previousHeight === height) return;

  previousHeight = height;

  const payload = {
    height,
    id: embedID,
  };

  sendMessageToParent(payload);
}

function createMutationObserver(target: HTMLElement, embedID: string) {
  const config: MutationObserverInit = {
    attributes: true,
    childList: true,
    subtree: true,
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach(() => {
      onResize(target, embedID);
    });
  });

  observer.observe(target, config);

  return observer;
}

function createResizeObserver(target: HTMLElement, embedID: string) {
  const observer = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.target !== target) return;

      onResize(target, embedID);
    });
  });

  observer.observe(target);

  return observer;
}

export function createHeightObserver(embedID: string) {
  const target = document.documentElement ?? document.body;

  const observer =
    "ResizeObserver" in window
      ? createResizeObserver(target, embedID)
      : createMutationObserver(target, embedID);

  return {
    disconnect: observer.disconnect,
  };
}

export function isInIFrame(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}
